<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-toolbar-title>Statement Line Type Helplist - Release</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.stmtLnType }}</td>
                  <td class="text-xs-left">{{ row.item.stmtLnTypeDesc }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      stmtLnTypeRel: 'stmtLnTypeRel',
      stmtLnType: 'stmtLnType',
      headers: [
        { text: 'Statement Line Type', value: 'stmtLnType' },
        { text: 'Statement Line Type Description', value: 'stmtLnTypeDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      labels: {
        stmtLnType: 'Statement Line Type',
        stmtLnTypeDesc: 'Statement Line Type Description'
      },
      filters: {
        stmtLnType: undefined,
        stmtLnTypeDesc: undefined
      },
      loading: false,
      selectedStmtLnType: undefined,
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getStmtLnTypeList
      if (apiURI) {
        this.loading = true
        try {
          this.loading = true
          let expand = {
            stmtLnType: this.stmtLnType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((stmtLnType) => {
                const convertList = {
                  stmtLnType: stmtLnType.stmtLnType,
                  stmtLnTypeDesc: stmtLnType.stmtLnTypeDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSelect(data) {
      const stmtLnTypeRelObj = {
        stmtLnTypeRtnRel: this.stmtLnTypeRel,
        stmtLnType: data.stmtLnType,
        stmtLnTypeDesc: data.stmtLnTypeDesc
      }
      this.$emit('selectStmtLnTypeRel', stmtLnTypeRelObj)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.rtnType.menu
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>

<style>
</style>
